export default class CustomFileInput {
  constructor(element) {
    this.actualBtn = element;
    this.fileChosenHtml = document.createElement("span");

    this.createFileInputLabel();
    this.onChangeFileInput();
  }

  createFileInputLabel() {
    this.fileChosenHtml.classList.add("file-input-label");
    this.fileChosenHtml.innerHTML = "No file chosen";
    this.actualBtn.after(this.fileChosenHtml);
  }

  onChangeFileInput() {
    this.actualBtn.addEventListener("change", (e) => {
      if (e.currentTarget.files.length) {
        this.fileChosenHtml.innerHTML = e.currentTarget.files[0].name;
      }
    });
  }
}
